<template>
  <div class="table">
    <div class="container">
     <div>
         <p class="icon-jujue closeBtn" @click="routerBack"></p>
     </div>
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select v-model="queryCondition.category3Code"  clearable placeholder="请选择" style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3List" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                      <el-input v-model="queryCondition.sponsorName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL Group" prop="aslGroupName">
                      <el-input v-model="queryCondition.aslGroupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="药品一级分类" prop="medicineLevelOneGrade">
                      <el-select v-model="queryCondition.medicineLevelOneGrade" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in medicineLevelOneGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="WHO 分类" prop="medicineLevelTwoGrade">
                      <el-select v-model="queryCondition.medicineLevelTwoGrade" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in medicineLevelTwoGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="OIE 药物等级" prop="oieMedicineGrade">
                      <el-select v-model="queryCondition.oieMedicineGrade" clearable  filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in oieMedicineGradeList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="有效成分" prop="effectiveComponents">
                      <el-select v-model="queryCondition.effectiveComponents" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in effectiveComponentsList" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="通用名" prop="commonName">
                      <el-input v-model="queryCondition.commonName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="商品名" prop="productName">
                      <el-input v-model="queryCondition.productName" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="药品状态" prop="medicineUseStatus">
                        <ic-select table="TT_RMC_PROTEIN_MEDICINE" filterable field="MEDICINE_USE_STATUS" clearable v-model="queryCondition.medicineUseStatus"  style="width:100%"></ic-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="提交时间从" prop="submitDateFrom">
                        <el-date-picker v-model="queryCondition.submitDateFrom" type="date" clearable style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="提交时间至" prop="submitDateTo">
                        <el-date-picker v-model="queryCondition.submitDateTo" type="date" clearable style="width:100%"></el-date-picker>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button  size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <!-- <el-row class="action-btn-row">
        <el-button  size="mini" class="btn" type="primary" @click="onCreate">新增</el-button>
        <el-button  size="mini" class="btn" type="danger" @click="onDel">删除</el-button>
      </el-row> -->
      <ux-grid ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="tooltip" highlight-current-row>
        <ux-table-column align="center" type="checkbox" width="80" />
        <ux-table-column align="center" title="提交时间" field="submitDate"  width="120" />
        <ux-table-column align="center" title="修改原因" field="modifyReason"  width="120" />
        <ux-table-column align="center" title="药品状态" field="medicineUseStatusI18n"  width="120" />
        <ux-table-column align="center" title="Category3" field="category3Name"  width="120" />
        <ux-table-column align="center" title="Sponsor" min-width="100" field="sponsorName"></ux-table-column>
        <ux-table-column align="center" title="ASL Group" min-width="120" field="aslGroupName"></ux-table-column>
        <ux-table-column align="center" title="药品一级分类" min-width="140" field="medicineLevelOneGrade"></ux-table-column>
        <ux-table-column align="center" title="WHO分类" min-width="100" field="medicineLevelTwoGrade"></ux-table-column>
        <ux-table-column align="center" title="WHO药品等级" min-width="120" field="whoMedicineGrade"></ux-table-column>
        <ux-table-column align="center" title="OIE药物等级" min-width="100" field="oieMedicineGrade"></ux-table-column>
        <ux-table-column align="center" title="有效成分" min-width="120" field="effectiveComponents"></ux-table-column>
        <ux-table-column align="center" title="通用名" min-width="120" field="commonName"></ux-table-column>
        <ux-table-column align="center" title="商品名" min-width="120" field="productName"></ux-table-column>
        <ux-table-column align="center" title="兽药批准文号" min-width="120" field="approvelNumber"></ux-table-column>
        <ux-table-column align="center" title="有效成分和含量" min-width="120" field="effectiveComponentsContent"></ux-table-column>
        <ux-table-column align="center" title="适应症" min-width="120" field="indication"></ux-table-column>
        <ux-table-column align="center" title="生产厂家" min-width="120" field="producer"></ux-table-column>
        <ux-table-column align="center" title="规格" min-width="120" field="specification"></ux-table-column>
        <ux-table-column align="center" title="用法和用量" min-width="120" field="usage"></ux-table-column>
        <ux-table-column align="center" title="休药期(天)" min-width="120" field="withdrawalDay"></ux-table-column>
        <ux-table-column align="center" title="养殖模式" min-width="120" field="breedingModeView"></ux-table-column>
        <ux-table-column align="center" title="最新检测时间" min-width="120" field="lastDetectionTime"></ux-table-column>
        <ux-table-column align="center" title="检测报告" min-width="120" field="createDate">
            <template v-slot="scope">
                <el-button type="text" @click="onGrade(scope.row)">查看</el-button>
            </template>
        </ux-table-column>
        <ux-table-column align="center" title="提交人" min-width="120" field="submitUser"></ux-table-column>
      </ux-grid>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount">
        </el-pagination>
      </div>

      <el-dialog title="" :visible.sync="fileleDialog" width="60%">
        <div slot="title" class="header-title">
            <div class="info_box_title" style="padding-left:10px;box-sizing: border-box;">
                <p class="line"></p>
                <p class="info_title">检测报告</p>
            </div>
        </div>
        <fileleDialog v-if="fileleDialog" :fileList="fileList"></fileleDialog>
    </el-dialog>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
// import detailDialog from './MaintainceFacility.vue'
import ratingTask from "@/api/AAA/ratingTask.js";
import QBRApi from "@/api/QBR/index";
import apiService  from "@/api/AAA/index.js";
import commonFunction from "@/utils/dataTableUtils";
import proteinDrug from "@/api/rmcProtein/drug";
import fileleDialog from '@/components/page/RMC/Protein/rmcDrugList/dialog/fileleDialog'


export default {
  name: '',
  components: {
    IcSelect,
    fileleDialog
  },
  data() {
    return {
      fileleDialog:false,
      identity:localStorage.getItem('ms_emplFlag'),
      allDate:[],
      medicineLevelOneGradeList:[],
      medicineLevelTwoGradeList:[],
      oieMedicineGradeList:[],
      effectiveComponentsList:[],
      multipleSelection:[],
      categoryList2: [],
      category3List: [],
      statusList: [],
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        status: "",
         proteinMedicineIds:JSON.parse(sessionStorage.getItem('drugId'))
      },
      isShow: false,
      showDetailDialog:false,
      tableData: [],
      formData:null,
      totalCount:"",
      statusView:"",
      fileList:[],
    }
  },
  created() {
    this.getdCategory3()
    this.getDrugGrade()
    this.queryData();
  },
  methods: {
    queryData() {
      proteinDrug.queryHistoryPage(this.queryCondition).then((res)=>{
        console.log("查看历史====",res)
        this.tableData=res.resultData
        this.totalCount=res.totalCount
      })
    },
    openHistory(){
      console.log("查看历史",this.multipleSelection)
    },
    onGrade(row){
      this.fileleDialog=true
      QBRApi.getFileLists({
        tsReckindId: "PROTEIN_MEDICINE",
        tsRecId: row.ttRmcProteinMedicineId
      }).then(res => {
        this.fileList = res
      });
    },
    onAbarbeitung(row){
      console.log("整改的数据=====",row)
      sessionStorage.setItem("taskDetail",JSON.stringify(row))
      this.$router.push({
        path:"/sponsormarkSheet",
        query:{

        }
      })
    },
    getdCategory3(){
      proteinDrug.getdCategory3().then((res)=>{
        this.category3List=res.data.filter((v)=>{
          return v.cascadeKey=='protein'
        })
      })
    },
    onReset() {
      this.queryCondition={
        pageNum: 1,
        pageSize: 15,
        status: "",
      }
      // this.$refs['queryCondition'].resetFields();
      this.queryCondition.pageNum=1
      this.queryData();
    },
    onCreate() {
      
    },
    pageSizeChange(val){
      this.queryCondition.pageSize = val
      this.queryData()
    },
    pageNumberChange(val){
      this.queryCondition.pageNum = val
      this.queryData()
    },
    onDel() {
      
    },
    selectionChange(val){
      this.multipleSelection=val
    },
    getDrugGrade(){
      proteinDrug.queryNatureForSelect().then((res)=>{
        // 有效成分
        res.data.effectiveComponentsList.forEach((v)=>{
          let obj={}
          obj.name=v
          obj.code=v
          this.effectiveComponentsList.push(obj)
        })
        // 药品一级分类
        res.data.medicineLevelOneGradeList.forEach((v)=>{
          let obj={}
          obj.name=v
          obj.code=v
          this.medicineLevelOneGradeList.push(obj)
        })
        // 药品二级分类
        res.data.medicineLevelTwoGradeList.forEach((v)=>{
          let obj={}
          obj.name=v
          obj.code=v
          this.medicineLevelTwoGradeList.push(obj)
        })
        // WHO药品等级
        // res.data.whoMedicineGradeList.forEach((v)=>{
        //   let obj={}
        //   obj.name=v
        //   obj.code=v
        //   this.whoMedicineGradeList.push(obj)
        // })
        // OIE药物等级
        res.data.oieMedicineGradeList.forEach((v)=>{
          let obj={}
          obj.name=v
          obj.code=v
          this.oieMedicineGradeList.push(obj)
        })
        console.log("获取的所以药品分类====",res)
      })
    },
    routerBack(){
        this.$router.back();
    },
    openDetail(row){
      console.log("rworoor==",row)
    }
    
  },
  extends: commonFunction
}
</script>
<style scoped >
.info_box_title {
  height: 30px;
  margin-top: 10px !important;
  display: flex;
  flex-direction: row;
  justify-content: start;
}
</style>
